export default {
  title: 'Settings',
  reservation_hours_helper: 'These hours define when guests can make reservations online.',
  reservation_hours_alert:
    'Your reservation hours differ from your regular opening hours. Guests can only book during the hours listed here.',
  activated: 'Reservations active',
  deactivated: 'Reservations inactive',
  buttons: {
    activate: 'Activate',
    deactivate: 'Deactivate',
  },
  error_messages: {
    no_google_place: {
      title: 'The restaurant is not connected with any google location',
      description: 'Please connect the restaurant to a google location',
    },
    toggle_failed: 'Could not update reservations. Please try again.',
  },
};
